import isPrintMode from 'ca-environment/isPrintMode';

export default function hasRequestCapability() {
  // We can't make http requests in print environment, as wkhtmltopdf can't load
  // non-public URLs. instead, all required data should be bootstrapped on page
  // generated by server.
  return !isPrintMode();
}
